import { render } from "./Loading.vue?vue&type=template&id=5cbce10b&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=5cbce10b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbce10b"]])

export default __exports__